import { render, staticRenderFns } from "./TheLeagueProfile.vue?vue&type=template&id=59c02d1f&scoped=true"
import script from "./TheLeagueProfile.vue?vue&type=script&lang=ts"
export * from "./TheLeagueProfile.vue?vue&type=script&lang=ts"
import style0 from "./TheLeagueProfile.vue?vue&type=style&index=0&id=59c02d1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c02d1f",
  null
  
)

export default component.exports